import { Inject, Injectable, LOCALE_ID, NgModule, inject, provideAppInitializer } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AuthModule } from "./pages/auth/auth.module";
import { BoxesModule } from "./boxes/boxes.module";
import { MatIconModule } from "@angular/material/icon";
import { HttpClient, provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { registerLocaleData } from "@angular/common";
import localeIT from '@angular/common/locales/it';
import localeES from '@angular/common/locales/es';
import localeCA from '@angular/common/locales/ca';
import localeEN from '@angular/common/locales/en';
import localeFR from '@angular/common/locales/fr';
import { MatSnackBarModule as MatSnackBarModule } from "@angular/material/snack-bar";
import { LayoutModule } from "./components/layout/layout.module";
import { DateAdapter, MAT_DATE_LOCALE, MatNativeDateModule, NativeDateAdapter } from "@angular/material/core";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { DirectivesModule } from "./providers/directives/directives.module";
import { MatCardModule } from "@angular/material/card";
import { MatButtonModule } from "@angular/material/button";
import { PopUpComponentModule } from "./components/pop-up-component/pop-up-component.module";
import { InitializeGlobalVariableService } from './providers/service/initialize-global-variable.service';
import {version as appVersion} from "../../package.json";


const HttpLoaderFactory = (http: HttpClient) => {
 // Cache-busting: gli asset i18n NON vengono hashati da Angular,
    // quindi appendiamo la versione dell'app per forzare il refresh ad ogni build.
    return new TranslateHttpLoader(http, '../assets/i18n/', `.json?v=${appVersion}`);
};

registerLocaleData(localeIT);
registerLocaleData(localeEN);
registerLocaleData(localeES);
registerLocaleData(localeCA);
registerLocaleData(localeFR);


@Injectable()
export class CustomDateAdapter extends NativeDateAdapter {
    constructor(@Inject(LOCALE_ID) public locale: string) {
        super(locale);
    }

    // Override il metodo per formattare la data in base alla lingua
    override format(date: Date, displayFormat: Object): string {
        if (!date) return '';
        // Usa Intl.DateTimeFormat per formattare la data
        return new Intl.DateTimeFormat(this.locale, {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
        }).format(date);
    }

    // Override il metodo per analizzare la stringa della data
    override parse(value: any): Date | null {
        if (typeof value === 'string') {
            const parts = value.split('/');
            const day = parseInt(parts[0], 10);
            const month = parseInt(parts[1], 10) - 1; // I mesi sono indicizzati da 0
            const year = parseInt(parts[2], 10);
            return new Date(year, month, day);
        }
        return null;
    }
}

@NgModule({ declarations: [
        AppComponent,
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        }),
        AppRoutingModule,
        BrowserAnimationsModule,
        MatCardModule,
        AuthModule,
        BoxesModule,
        MatIconModule,
        MatSnackBarModule,
        LayoutModule,
        MatNativeDateModule,
        MatNativeDateModule,
        DirectivesModule,
        MatButtonModule,
        PopUpComponentModule], providers: [
        provideAppInitializer(() => {
        const initializerFn = ((globalService: InitializeGlobalVariableService) => () => globalService.initializeGlobalVariable())(inject(InitializeGlobalVariableService));
        initializerFn();
      }),
        { provide: DateAdapter, useClass: CustomDateAdapter },
        provideHttpClient(withInterceptorsFromDi()),
    ] })
export class AppModule {
}